export default __webpack_public_path__ + "static/media/sell_dress_image.8f67710e.png";